import { render } from "./OtpSection.vue?vue&type=template&id=6ac2d833&scoped=true"
import script from "./OtpSection.vue?vue&type=script&lang=js"
export * from "./OtpSection.vue?vue&type=script&lang=js"

import "./OtpSection.vue?vue&type=style&index=0&id=6ac2d833&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ac2d833"]])

export default __exports__